import type { RouteObject } from "react-router-dom";
import { Navigate, useParams, useSearchParams } from "react-router-dom";

// The wiki moved into Contacts. Links already sent to `/wiki/<slug>` (and the
// old `?view=map` overview) land on the same page there.
function WikiRedirect({ slug }: { slug?: string }) {
  const params = useParams();
  const [searchParams] = useSearchParams();
  const view = searchParams.get("view");
  const target =
    view === "map" || view === "graph"
      ? "memory-map"
      : (slug ?? params.slug ?? "overview");
  return (
    <Navigate
      to={`../people?view=people&slug=${encodeURIComponent(target)}`}
      replace
    />
  );
}

export const wikiRoutes: RouteObject[] = [
  { path: "wiki", element: <WikiRedirect /> },
  { path: "wiki/changelog", element: <WikiRedirect slug="recent-updates" /> },
  { path: "wiki/memory-map", element: <WikiRedirect slug="memory-map" /> },
  { path: "wiki/:slug", element: <WikiRedirect /> },
];
